import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Tmov({ size, color }: IconProps) {
  return (
    <svg
      width={size || 24}
      height={size || 24}
      viewBox="0 0 29 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Tmov</title>
      <path
        d="M18.0851 0.804199L20.8579 3.5813L7.65164 16.799V0.804199H0.252441V26.7758H4.57697C6.54407 26.7758 8.43234 25.9925 9.82449 24.6011L25.842 8.56969L28.6148 11.3468V0.804199H18.0851Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
